import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Accordion, Button, Image, Row } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { isBrowser } from "react-device-detect";
import { renderRoutes } from "react-router-config";

import { Cookie } from "../utils/Cookies";

import routes from "./RouteSetting";

const root = process.env.PUBLIC_URL + "/";  

class MainPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    console.log("create main page");
  }

  onPressLogout = () => {
    this.props.screenProps.onLogout();
  };
  renderMobileNaviView() {
    return (
      <Accordion className="col-xl-2 bg-light p-0">
        <Accordion.Toggle
          as={Button}
          variant="link"
          eventKey="mobileMenu"
          className="nav-link border-0"
          style={{ maxwidth: "100%" }}
        >
          <Image src={root + "images/logo.png"} style={{ maxWidth:"100%",maxHeight:"100%" }} />
          <b>
            <FormattedMessage id="mainPage.navimenu" />
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="mobileMenu">
          {this.renderNaviMenu()}
        </Accordion.Collapse>
      </Accordion>
    );
  }

  renderBrowserNaviView() {
    return (
      <div className="p-0" style={{ width: "15%" }}>
        <div
          style={{
            backgroundColor: "#0032A0",
            width: "100%",
            height: "75px",
            "text-align": "center",
            "line-height": "65px",
          }}
          className="mx-auto"
        >
          <Image
            src={root + "images/logo.png"}
            style={{ width: "80%", height: "50%" }}
          />
        </div>
        {this.renderNaviMenu()}
      </div>
    );
  }

  renderNaviMenu() {
    const path = this.props.location.pathname;
    let bgcolor = [
      path === "/" ? "#cdedfc" : "#fff",
      path.startsWith("/Analysis") ? "#cdedfc" : "#fff",
      path.startsWith("/Organization") ? "#cdedfc" : "#fff",
      path.startsWith("/Users") ? "#cdedfc" : "#fff",
      path.startsWith("/SettingPage") ? "#cdedfc" : "#fff",
      path.startsWith("/FoodMenu") ? "#cdedfc" : "#fff",
    ];
    return (
      <nav className="navbar navbar-light p-0">
        <ul className="navbar-nav w-100">
          <li
            className="nav-item"
            style={{ paddingLeft: "10px", backgroundColor: bgcolor[0] }}
          >
            <Link to="/" className="nav-link" style={{ color: "#0032A0" }}>
              <Image
                src={root + "icon/dashboard.png"}
                style={{ marginRight: "15px" }}
              />
              <FormattedMessage id="mainPage.dashboard" />
            </Link>
          </li>
          <li className="nav-item">
            <Accordion>
              <Link
                to="/Analysis/pos"
                className="nav-link p-0"
                style={{ color: "#0032A0" }}
              >
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="analysismenu"
                  style={{
                    color: "#0032A0",
                    paddingLeft: "10px",
                    backgroundColor: bgcolor[1],
                  }}
                  className="nav-link border-0 rounded-0 w-100 d-flex justify-content-start align-items-center"
                >
                  <Image
                    src={root + "icon/analysis.png"}
                    style={{ marginRight: "9px" }}
                  />
                  <FormattedMessage id="mainPage.analysis" />
                </Accordion.Toggle>
              </Link>
              <Accordion.Collapse
                eventKey="analysismenu"
                style={{ marginLeft: "48px" }}
              >
                <ul className="navbar-nav">
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/pos"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.pos" />
                    </Link>
                    {path === "/Analysis/pos" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/line"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.line" />
                    </Link>
                    {path === "/Analysis/line" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/report"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.report" />
                    </Link>
                    {path === "/Analysis/report" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/rfm"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.rfm" />
                    </Link>
                    {path === "/Analysis/rfm" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/furniture"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.furniture" />
                    </Link>
                    {path === "/Analysis/furniture" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Analysis/supplier"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="analysis.supplier" />
                    </Link>
                    {path === "/Analysis/supplier" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                </ul>
              </Accordion.Collapse>
            </Accordion>
          </li>
          {/*
          <li
            className="nav-item"
            style={{ paddingLeft: "10px", backgroundColor: "#fff" }}
          >
            <a
              href="http://vectormember.aiv.com.tw/"
              target="_blank"
              className="nav-link"
              style={{ color: "#0032A0" }}
            >
              <Image
                src={root + "icon/customers.png"}
                style={{ marginRight: "12px" }}
              />
              <FormattedMessage id="mainPage.membership" />
            </a>
          </li>
          */}
          <li
            className="nav-item"
            style={{ paddingLeft: "10px", backgroundColor: bgcolor[5] }}
          >
            <Link
              to="/FoodMenu"
              className="nav-link"
              style={{ color: "#0032A0" }}
            >
              <Image
                src={root + "icon/foodmenu.png"}
                style={{ marginRight: "19px" }}
              />
              <FormattedMessage id="mainPage.foodmenu" />
            </Link>
          </li>
          {/*
          <li className="nav-item" style={{paddingLeft: "10px", backgroundColor: bgcolor[2]}}>
            <Link to="/Organization" className="nav-link" style={{ color: "#00a0e9" }}><Image src={root+"icon/organization.png"} style={{ marginRight: "15px" }} /><FormattedMessage id="mainPage.organization" /></Link>
          </li>
          */}
          <li className="nav-item">
            <Accordion>
              <Link
                to="/Users/UserList"
                className="nav-link p-0"
                style={{ color: "#0032A0" }}
              >
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey="navimenu"
                  style={{
                    color: "#0032A0",
                    paddingLeft: "10px",
                    backgroundColor: bgcolor[3],
                  }}
                  className="nav-link border-0 rounded-0 w-100 d-flex justify-content-start align-items-center"
                >
                  <Image
                    src={root + "icon/users.png"}
                    style={{ marginRight: "16px" }}
                  />
                  <FormattedMessage id="mainPage.users" />
                </Accordion.Toggle>
              </Link>
              <Accordion.Collapse
                eventKey="navimenu"
                style={{ marginLeft: "48px" }}
              >
                <ul className="navbar-nav">
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Users/UserList"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="mainPage.users.list" />
                    </Link>
                    {path === "/Users/UserList" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  {/* <li className="nav-item d-flex justify-content-between">
                    <Link to="/Users/CreateUser" className="nav-link p-0" style={{ color: "#00a0e9" }}><FormattedMessage id="mainPage.users.create" /></Link>
                    {
                      path === "/Users/CreateUser" ? 
                      <span style={{ color: "#00a0e9" }}>◄</span>
                      : null
                    }
                  </li> */}
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Users/PersonalInfo"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="mainPage.users.personal" />
                    </Link>
                    {path === "/Users/PersonalInfo" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                  <li className="nav-item d-flex justify-content-between">
                    <Link
                      to="/Users/PermissionSetting"
                      className="nav-link p-0"
                      style={{ color: "#0032A0" }}
                    >
                      <FormattedMessage id="mainPage.users.permission" />
                    </Link>
                    {path === "/Users/PermissionSetting" ? (
                      <span style={{ color: "#0032A0" }}>◄</span>
                    ) : null}
                  </li>
                </ul>
              </Accordion.Collapse>
            </Accordion>
          </li>
          <li
            className="nav-item"
            style={{ paddingLeft: "10px", backgroundColor: bgcolor[4] }}
          >
            <Link
              to="/SettingPage"
              className="nav-link"
              style={{ color: "#0032A0" }}
            >
              <Image
                src={root + "icon/setting.png"}
                style={{ marginRight: "17px" }}
              />
              <FormattedMessage id="mainPage.setting" />
            </Link>
          </li>
        </ul>
      </nav>
    );
  }

  render() {
    let rightAreaStyle = {};
    if (isBrowser) {
      rightAreaStyle = { borderLeft: "2px solid #ccc", width: "85%" };
    }

    return (
      <Row>
        {isBrowser ? this.renderBrowserNaviView() : this.renderMobileNaviView()}
        <div className="p-0" style={rightAreaStyle}>
          <nav
            className="navbar navbar-expand-sm navbar-dark d-flex flex-row-reverse text-body"
            style={{
              backgroundImage: "url('/images/bar_bg.png')",
              backgroundSize: "100% 100%",
            }}
          >
            <Dropdown>
              <Dropdown.Toggle
                as={Button}
                variant="link"
                className="border-0 text-dark"
              >
                {Cookie.get("LoginUser")}
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight>
                <Dropdown.Item eventKey="1" onClick={this.onPressLogout}>
                  <FormattedMessage id="mainPage.logout" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Image src={root + "icon/dashboardlogo.png"}
            style={{marginRight: "30px" }}
            />
          </nav>
          <div
            className="p-0"
            style={{
              height: "94vh",
              backgroundColor: "#f5f5f5",
              overflow: "auto",
            }}
          >
            {renderRoutes(routes)}
          </div>
        </div>
      </Row>
    );
  }
}

export default withRouter(MainPage);
